import { Component, OnInit } from '@angular/core';5
import { ProspectService } from 'services/prospect.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AgentShowingOption } from 'app/models/agent-showing-option';
import { SplashService } from 'services/splash.service';
import { TrackingParameters } from 'app/models/tracking-parameter';
import { ErrorService } from 'services/error.service';

@Component({
  selector: 'app-showing-timeselect',
  templateUrl: './showing-timeselect.component.html',
  styleUrls: ['./showing-timeselect.component.css']
})
export class ShowingTimeselectComponent implements OnInit {

    selectedDate: Date = new Date();
    selectedDateString: string = null;
    address: string = null;
    yardiKey: string = null;
    errorMessage: string = null;
    showings: AgentShowingOption[];
    selectedShowing: AgentShowingOption = null;
    sub: any;
    showLoader: boolean = true;
    isProcessing: boolean = false;

  constructor(public errorService: ErrorService, private prospectService: ProspectService, public router: Router, public route: ActivatedRoute, private splashService: SplashService
    ) {

    let address = localStorage.getItem('PropertyAddress');
    let yardiKey = localStorage.getItem('YardiID');
    let showingDate = localStorage.getItem('SelectedShowingDate');

    if (address !== null && address !== undefined)
    {
      this.address = address;
    }

    if (yardiKey !== null && yardiKey !== undefined)
    {
      this.yardiKey = yardiKey;
    }

    if (showingDate !== null && showingDate !== undefined)
    {
      this.selectedDate = new Date(showingDate);
      this.selectedDateString = this.selectedDate.toDateString();
    }

    this.prospectService.getShowingOptions(this.yardiKey, this.selectedDate).subscribe(res => this.onGetShowingOptions(res), msg => this.onError(msg));

   }

  ngOnInit() {
    this.splashService.updateSplash("agenttour");
    this.isProcessing = false;

  }

  onGetShowingOptions(options: AgentShowingOption[])
  {
    this.showLoader = false;
    this.showings = options;
    if(options == null || options.length == 0) {
      this.errorService.showError("No showing times found")
    }
  }

  onError(msg) {
    this.errorService.showError(msg);
  }

  onSubmit(){

    this.isProcessing = true;   
    this.LoadFromLocalTourQueryParams();
    this.prospectService.createShowingForProspect(this.selectedShowing).subscribe(res => this.onCreateShowing(res), res => this.errorMessage ="Error creating showing.");
  }

  onCreateShowing(showingKey: number)
  {
    this.router.navigate(['/tour/toursummary', showingKey]);
  }

  LoadFromLocalTourQueryParams()
  {
      let paramsString = localStorage.getItem('TrackingParameters');

      if (paramsString)
      {
          let params: TrackingParameters = JSON.parse(paramsString);
          this.selectedShowing.ProspectSource = params.Source;
          this.selectedShowing.Campaign = params.Campaign;
          this.selectedShowing.AdGroup = params.AdGroup;
          this.selectedShowing.Keyword = params.Keyword;
          this.selectedShowing.AdCopy = params.AdCopy;
          this.selectedShowing.Device = params.Device;
          this.selectedShowing.Medium = params.Medium;
      }
  }

  changeDate()
  {
    this.router.navigate(['/tour/showingdateselect']);
  }

  selectShowing(index: number)
  {
    this.showings.forEach(show => {
      show.Selected = false;
    });

    this.showings[index].Selected = true;
    this.selectedShowing = this.showings[index];
  }

}
